import axios from 'axios';
// config
import { HOST_API_KEY } from '../config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API_KEY });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export const axiosPrivate = axios.create({
    baseURL: HOST_API_KEY,
    headers: { 'Content-Type': 'application/json' },
});

export const axiosPrivateMultipart = axios.create({
    baseURL: HOST_API_KEY,
    headers: { 'Content-Type': 'multipart/form-data' },
});

export default axiosInstance;
